import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WNonFeaturedArticlesCCD: IClientComponentDefinition = {
  name: 'WNonFeaturedArticles',
  load: () => import(/* webpackChunkName: 'WNonFeaturedArticles' */ './index'),
}
